const bestWorks = () => import('@/pages/bestWorks/bestWorks.vue');

export default [{
  path: '/bestWorks',
  name: 'bestWorks',
  meta: {
    isLogin: false
  },
  component: bestWorks
}, ]